import { createAsyncThunk } from "@reduxjs/toolkit";

import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { GetMyExpenses, GetAllExpenses, ApplyForExpense, ExpenseApprovals, GetExpensesForApprover, DeleteExpense, SubmitExpensesForApproval, MarkExpenseAsPaid, GetExpenseByID, UpdateExpense } from "helpers/api_method";

export const getMyExpenses = createAsyncThunk("expenses/getMyExpenses", async (_, { rejectWithValue }) => {
    try {
        const response = await GetMyExpenses();
        // Handle different response structures
        if (response?.data) {
            return response.data;
        }
        if (response?.status && response?.data !== undefined) {
            return response.data;
        }
        return response;
    } catch (error: any) {
        console.error('Error fetching my expenses:', error);
        return rejectWithValue(error?.response?.data || error?.message || 'Failed to fetch expenses');
    }
});

export const getAllExpenses = createAsyncThunk("expenses/getAllExpenses", async () => {
    try {
        const response = await GetAllExpenses();
        return response;
    } catch (error) {
        return error;
    }
});

export const getExpensesForApprover = createAsyncThunk("expenses/getExpensesForApprover", async (_, { rejectWithValue }) => {
    try {
        const response = await GetExpensesForApprover();
        // Handle different response structures
        if (response?.data) {
            return response.data;
        }
        if (response?.status && response?.data !== undefined) {
            return response.data;
        }
        return response;
    } catch (error: any) {
        console.error('Error fetching expenses for approver:', error);
        return rejectWithValue(error?.response?.data || error?.message || 'Failed to fetch expenses');
    }
});

export const createNewExpense = createAsyncThunk("expenses/createNewExpense", async (event: any) => {
    try {
        const response = await ApplyForExpense(event);
        return response;
    } catch (error) {
        return error;
    }
});

export const getExpenseByID = createAsyncThunk("expenses/getExpenseByID", async (expense_id: string, { rejectWithValue }) => {
    try {
        const response = await GetExpenseByID(expense_id);
        if (response?.data) {
            return response.data;
        }
        if (response?.status && response?.data !== undefined) {
            return response.data;
        }
        return response;
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || error?.message || 'Failed to fetch expense');
    }
});

export const updateExpense = createAsyncThunk("expenses/updateExpense", async (event: { expense_id: string; data: any }, { rejectWithValue }) => {
    try {
        const response = await UpdateExpense(event.expense_id, event.data);
        return response;
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || error?.message || 'Failed to update expense');
    }
});

export const approveExpense = createAsyncThunk("expenses/approveExpense", async (event: any) => {
    try {
        const response = await ExpenseApprovals(event.id, event);
        return response;
    } catch (error) {
        return error;
    }
});

export const deleteExpense = createAsyncThunk("expenses/deleteExpense", async (expense_id: string) => {
    try {
        const response = await DeleteExpense(expense_id);
        return response;
    } catch (error) {
        return error as any;
    }
});

export const submitExpensesForApproval = createAsyncThunk("expenses/submitExpensesForApproval", async (cycle_string: string, { rejectWithValue }) => {
    try {
        const response = await SubmitExpensesForApproval({ cycle_string });
        return response;
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || error?.message || 'Failed to submit expenses for approval');
    }
});

export const markExpenseAsPaid = createAsyncThunk("expenses/markExpenseAsPaid", async (data: { expense_id: string; payment_reference?: string }, { rejectWithValue }) => {
    try {
        const response = await MarkExpenseAsPaid(data.expense_id, { payment_reference: data.payment_reference });
        return response;
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || error?.message || 'Failed to mark expense as paid');
    }
});

